import { checkCafe } from "@/apis/gnb";
import { NX_LATC_COOKIE, NX_TPA_COOKIE } from "@/consts/cookies";
import { getIsStellaAccessCode } from "@/lib/stella";
import { getCookies, getIsForcedNonCafe, setCookie, setSessionStorage } from "@/lib/utils";
import CookieStore from "@/stores/CookieStore";
import { useSearch } from "@tanstack/react-router";
import { useEffect, useState } from "react";

const CafeBanner = () => {
  const [showTopBanner, setShowTopBanner] = useState(false);
  const isCafe = CookieStore((state) => state.isCafe);
  const setIsCafe = CookieStore((state) => state.setIsCafe);

  useEffect(() => {
    if (getIsForcedNonCafe()) {
      return;
    }

    if (!isCafe) {
      // 쿠키 설정
      checkCafe()
        .then(({ isAtPcBang }) => {
          if (isAtPcBang) {
            setIsCafe(true);
            setShowTopBanner(true);
            // PC방 접속 시 최근 로그인 쿠키 삭제
            setSessionStorage("GNBTPA", getCookies(NX_TPA_COOKIE) ?? "");
            setCookie(NX_LATC_COOKIE, "", 0);
          } else {
            setIsCafe(false);
          }
        })
        .catch(() => {});
    } else {
      setShowTopBanner(true);
      // PC방 접속 시 최근 로그인 쿠키 삭제
      setCookie(NX_LATC_COOKIE, "", 0);
    }
  }, [isCafe, setIsCafe]);

  // 스텔라 진입: PC방 띠 숨김
  if (!showTopBanner || getIsStellaAccessCode()) {
    return null;
  }

  return (
    <div className="fixed left-0 top-0 z-50 w-screen bg-blue-600">
      <div className="flex justify-center px-4">
        <p className="py-[7px] text-center text-xs text-white">
          <strong className="mr-[5px]">PC방 접속중</strong>
          공공장소에서는 넥슨 ID/비밀번호 기록이 남지 않도록 넥슨플레이로 로그인하세요!
        </p>
      </div>
    </div>
  );
};

const SafeLoginBanner = () => {
  const { sec } = useSearch({ from: "/login/" });
  const [section, setSection] = useState("");
  const isCafe = CookieStore((state) => state.isCafe);

  useEffect(() => {
    if (sec === "pcbang") {
      setSection("일회용");
    } else if (sec === "qr") {
      setSection("QR");
    }
  }, [sec]);

  // 스텔라 진입: 일회용·QR 안내 띠 숨김
  if (isCafe || sec === "login" || !sec || getIsStellaAccessCode()) {
    return null;
  }

  return (
    <div className="fixed left-0 top-0 z-50 w-screen bg-gray-1000">
      <div className="flex justify-center px-4">
        <p className="py-[7px] text-center text-xs text-white">넥슨 ID/비밀번호 기록이 남지 않는 {section} 로그인!</p>
      </div>
    </div>
  );
};

const TopBanner = () => {
  return (
    <>
      <SafeLoginBanner />
      <CafeBanner />
    </>
  );
};

export default TopBanner;
